import { Component, OnInit } from "@angular/core";
import { DataService_MultiStationNotification } from "../data.service";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { LocalstorageService } from "../../../../../shared";

@Component({
	selector: "app-ms-notify-facility-select",
	templateUrl: "./ms-notify-facility-select.component.html",
	styleUrls: ["./ms-notify-facility-select.component.css"],
})
export class MsNotifyFacilitySelectComponent implements OnInit {
	constructor(
		private visitorService: DataService_MultiStationNotification,
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private localService: LocalstorageService
	) {}

	ngOnInit(): void {
		//
		//	10.15 Try to select a facility based on the last school that was selected
		//
		var lastSchool = this.localService.getItem("SchoolSelector_School");
		if (lastSchool != undefined && lastSchool.SchoolID != undefined) {
			this.LastSchoolID = lastSchool.SchoolID;
		}

		//Get Data from DB
		this.loadFacility();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	LastSchoolID: number = -1;

	lstFacility: any = [];
	SelectedFacilities: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "FacilityCD", header: "Code" },
		{ field: "FacilityName", header: "Name" },
	];

	loading: boolean = false;

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	private loadFacility() {
		this.loading = true;

		var result = this.visitorService.VisitorFacilitySelectList(this.LastSchoolID);
		result.subscribe(
			(response) => {
				var Selected: any = this.dialogConfig.data.SelectedFacilities;
				var Data: any = response;

				for (var z = 0; z < Data.length; z++) {
					var next = Data[z];

					var found = false;
					for (var x = 0; x < Selected.length; x++) {
						var select = Selected[x];

						if (next.FacilityID == select.FacilityID) {
							found = true;
						}
					}

					if (!found) {
						this.lstFacility = [...this.lstFacility, next];
					}
				}

				this.loading = false;

				// this.lstFacility = response;
				// this.UpdateSelected();
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	// UpdateSelected(){
	//   var FromMain: any = this.dialogConfig.data.SelectedSchools;

	//   console.log("Selected Schools");
	//   console.log(FromMain);

	//   console.log(FromMain.indexOf(this.lstSchool[0]));

	//   this.lstSchool = this.lstSchool.filter(school => FromMain.indexOf(school) == -1); //? Not working?
	//   console.log(this.lstSchool);
	// }
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		this.ref.close(this.SelectedFacilities);
	}
	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
